import Donut from "./Donut";

export default function AnalyticsPanel({ donutData }) {
  return (
    <div className="p-4 mb-8 bg-white rounded-xl border border-gray-200 shadow-sm">
      <h3 className="mb-4 text-sm font-semibold">Registration Analytics</h3>
      <div className="overflow-x-auto">
        <div className="flex gap-8 justify-between items-start w-full">
          <div className="space-y-2">
            <p className="text-xs text-gray-600">Registration</p>
            <div className="flex gap-4 items-center">
              <Donut
                size={132}
                thickness={16}
                segments={[
                  { value: 0, color: "#10b981" },
                  { value: 0, color: "#e5e7eb" },
                ]}
                centerText="0"
              />
            </div>
            <div className="grid grid-cols-2 gap-x-4 gap-y-1 pt-1 text-[11px] text-gray-600 justify-items-center w-full max-w-[200px] mx-auto">
              <div className="inline-flex gap-2 items-center">
                <span
                  className="inline-block w-2.5 h-2.5 rounded-full"
                  style={{ background: "#10b981" }}
                ></span>{" "}
                Complete
              </div>
              <div className="inline-flex gap-2 items-center">
                <span
                  className="inline-block w-2.5 h-2.5 rounded-full"
                  style={{ background: "#e5e7eb" }}
                ></span>{" "}
                Incomplete
              </div>
            </div>
          </div>

          <div className="flex flex-col flex-1 items-center text-center">
            <p className="mb-2 text-xs text-gray-600">Source</p>
            <Donut size={132} thickness={16} segments={[donutData.sources[0], donutData.sources[1]]} centerText="" />
            <div className="grid grid-cols-2 gap-x-6 gap-y-1 mt-2 text-[11px] text-gray-600 justify-items-center w-full max-w-[240px]">
              <div className="inline-flex gap-2 items-center">
                <span
                  className="inline-block w-2.5 h-2.5 rounded-full"
                  style={{ background: donutData.sources[0].color }}
                ></span>{" "}
                USSD
              </div>
              <div className="inline-flex gap-2 items-center">
                <span
                  className="inline-block w-2.5 h-2.5 rounded-full"
                  style={{ background: donutData.sources[1].color }}
                ></span>{" "}
                Web
              </div>
            </div>
          </div>
          <div className="flex flex-col flex-1 items-center text-center">
            <p className="mb-2 text-xs text-gray-600">Gender</p>
            <Donut
              size={132}
              thickness={16}
              segments={donutData.gender}
              centerText=""
            />
            <div className="grid grid-cols-2 gap-x-6 gap-y-1 mt-2 text-[11px] text-gray-600 justify-items-center w-full max-w-[240px]">
              <div className="inline-flex gap-2 items-center">
                <span
                  className="inline-block w-2.5 h-2.5 rounded-full"
                  style={{ background: donutData.gender[0].color }}
                ></span>{" "}
                Male
              </div>
              <div className="inline-flex gap-2 items-center">
                <span
                  className="inline-block w-2.5 h-2.5 rounded-full"
                  style={{ background: donutData.gender[1].color }}
                ></span>{" "}
                Female
              </div>
            </div>
          </div>
          <div className="flex flex-col flex-1 items-center text-center">
            <p className="mb-2 text-xs text-gray-600">Age</p>
            <Donut
              size={132}
              thickness={16}
              segments={donutData.age}
              centerText=""
            />
            <div className="grid grid-cols-2 gap-x-6 gap-y-1 mt-2 text-[11px] text-gray-600 justify-items-center w-full max-w-[240px]">
              <div className="inline-flex gap-2 items-center">
                <span
                  className="inline-block w-2.5 h-2.5 rounded-full"
                  style={{ background: donutData.age[0].color }}
                ></span>{" "}
                18–25
              </div>
              <div className="inline-flex gap-2 items-center">
                <span
                  className="inline-block w-2.5 h-2.5 rounded-full"
                  style={{ background: donutData.age[1].color }}
                ></span>{" "}
                26–35
              </div>
              <div className="inline-flex gap-2 items-center">
                <span
                  className="inline-block w-2.5 h-2.5 rounded-full"
                  style={{ background: donutData.age[2].color }}
                ></span>{" "}
                36–45
              </div>
              <div className="inline-flex gap-2 items-center">
                <span
                  className="inline-block w-2.5 h-2.5 rounded-full"
                  style={{ background: donutData.age[3].color }}
                ></span>{" "}
                46–60
              </div>
            </div>
          </div>
          <div className="flex flex-col flex-1 items-center text-center">
            <p className="mb-2 text-xs text-gray-600">Location</p>
            <Donut
              size={132}
              thickness={16}
              segments={donutData.location}
              centerText=""
            />
            <div className="grid grid-cols-2 gap-x-6 gap-y-1 mt-2 text-[11px] text-gray-600 justify-items-center w-full max-w-[240px]">
              <div className="inline-flex gap-2 items-center">
                <span
                  className="inline-block w-2.5 h-2.5 rounded-full"
                  style={{ background: donutData.location[0].color }}
                ></span>{" "}
                Accra
              </div>
              <div className="inline-flex gap-2 items-center">
                <span
                  className="inline-block w-2.5 h-2.5 rounded-full"
                  style={{ background: donutData.location[1].color }}
                ></span>{" "}
                Kumasi
              </div>
              <div className="inline-flex gap-2 items-center">
                <span
                  className="inline-block w-2.5 h-2.5 rounded-full"
                  style={{ background: donutData.location[2].color }}
                ></span>{" "}
                Takoradi
              </div>
              <div className="inline-flex gap-2 items-center">
                <span
                  className="inline-block w-2.5 h-2.5 rounded-full"
                  style={{ background: donutData.location[3].color }}
                ></span>{" "}
                Tamale
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
